import React, { Component } from "react";
import { observer, inject } from "mobx-react";
import PropTypes from "prop-types";
import { GridColumn, GridContainer, GridRow, Input } from "arv-reactcomponents";
import ApplicablePromosList from "../ApplicablePromosList";
import { Promotions } from "npmlinks-constants";

@inject("PromotionsStore")
@observer
class PromotionsList extends Component {
  constructor() {
    super();

    this.state = {
      isUserInputPromoSelected: false,
    };
    this.onPromoChange = this.onPromoChange.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.promoInputOnFocus = this.promoInputOnFocus.bind(this);
    this.promoInputOnBlur = this.promoInputOnBlur.bind(this);
  }

  onPromoChange({ target: { value } }) {
    this.props.setPromo(value);
    this.props.clearError();
  }
  handleInputChange(event) {
    const { target: { value } } = event;
    this.props.setPromo(value, true);
    this.props.clearError();
  }

  promoInputOnFocus() {
    this.setState({ isUserInputPromoSelected: true });
  }

  get applicablePromoInputClass() {
    return (
      (this.state.isUserInputPromoSelected && "nwc-inp-primary") ||
      "nwc-inp-secondary"
    );
  }

  promoInputOnBlur() {
    this.setState({ isUserInputPromoSelected: false });
  }

  render() {
    const {
      appPromos,
      promoErrorMessage,
      promoName,
      promoFromSelection,
    } = this.props;
    return (
      <GridContainer>
        <GridRow>
          <GridColumn className="nw-applicable-promo-col">
            <Input
              id="nw-app-promo-input"
              className={`${
                this.applicablePromoInputClass
              } nwc-inp-sm nw-applicable-promos-input`}
              onChange={this.handleInputChange}
              value={promoFromSelection}
              placeholder={Promotions.INPUT_PLACEHOLDER}
              onClick={this.promoInputOnFocus}
              onBlur={this.promoInputOnBlur}
            />
          </GridColumn>
        </GridRow>
        <GridRow>
          <GridColumn>
            {promoErrorMessage && (
              <div className="nw-applpromo-errormessage">
                {promoErrorMessage}
              </div>
            )}
          </GridColumn>
        </GridRow>
        <GridRow>
          {appPromos.length > 0 && (
            <GridColumn className="nw-apppromos-ortext">
              <span className="nw-apppromos-ortextspan">Or</span>
            </GridColumn>
          )}
        </GridRow>
        <GridRow>
          <GridColumn>
            {appPromos.map(promo => (
              <ApplicablePromosList.component
                promoData={promo}
                onPromoChange={this.onPromoChange}
                promoName={promoName}
                promoFromSelection={promoFromSelection}
              />
            ))}
          </GridColumn>
        </GridRow>
      </GridContainer>
    );
  }
}

PromotionsList.wrappedComponent.propTypes = {
  promoFromSelection: PropTypes.func.isRequired,
  setPromo: PropTypes.func.isRequired,
  promoName: PropTypes.string.isRequired,
  clearError: PropTypes.func.isRequired,
  promoErrorMessage: PropTypes.string.isRequired,
  appPromos: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};

const getFinalComponent = component =>
  inject("PromotionsStore")(observer(component));

const ProjectComponent = {
  getFinalComponent,
  wrapper: PromotionsList.wrappedComponent,
  component: PromotionsList,
};

export default ProjectComponent;



// WEBPACK FOOTER //
// ./src/component/Promotions/PromotionsList/index.js